import _ from 'lodash';
import {
  MODAL_ACTIONS,
  AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG,
  REQUEST_TYPE,
} from 'food-benefit.module/common/domain/constants';
import { MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';
import employeesDataFormatter from 'food-benefit.module/common/domain/formatters/employeesDataFormatter';

const PERMISSION = {
  USER: 'R',
};

class MyFoodBenefitController {
  constructor(
    $translate,
    $window,
    foodBenefitService,
    myFoodBenefitHelper,
    foodDelegationService,
    ManagerForEmployeeService,
    FoodBenefitUserDataService,
    $scope,
    HelperDelegationsService,
    loadingMobileService,
    floatingActionButtonsService,
    $timeout,
    $log
  ) {
    'ngInject';
    this.log = $log;
    this.translate = $translate;
    this.foodBenefitService = foodBenefitService;
    this.myFoodBenefitHelper = myFoodBenefitHelper;
    this.foodDelegationService = foodDelegationService;
    this.floatingActionButtonsService = floatingActionButtonsService;
    this.ManagerForEmployeeService = ManagerForEmployeeService;
    this.UserDataService = FoodBenefitUserDataService;
    this.scope = $scope;
    this.window = $window;
    this.isMobileApp = $window.innerWidth < 1024;
    this.loadingMobileService = loadingMobileService;
    this.loaded = false;
    this.cardModified = false;
    this.hasNoManager = false;
    this.delegation = {};
    this.helperDelegations = HelperDelegationsService;
    this.timeout = $timeout;
    this.coachmarkData = AA_MY_FOOD_BENEFIT_MODAL_COACHMARK_CONFIG;
    this.employee = this.UserDataService.getEmployee();
    this.userId = this.employee.userId;
    this.employeeopplus = false;
    this.openEmployeeSearch = false;
  }

  $onInit() {
    this._init();

    this.urlDestination = STATES.FOOD_BENEFIT.DELEGATE;

    this.scope.$watch(
      () => this.foodBenefitService.loaded,
      (newValue) => {
        if (newValue) {
          this._initData();
        }
      }
    );

    this._translate();

    this.visitedDelegation = this.helperDelegations.getVisitDelegation(
      this.userId,
      PERMISSION.USER
    );

    if (this.isMobileApp) {
      this.floatingActionButtons =
        this.myFoodBenefitHelper.getFloatingSendAllButton();
    }
  }

  get modalBenefitRequestList() {
    return $(MODALS.BENEFIT_REQUEST_LIST);
  }

  get modalWarningDelegation() {
    const $modal = $(MODALS.WARNING_DELEGATION_MODAL);
    $modal.on('hidden.bs.modal', () => {
      this.helperDelegations.setVisitedDelegation(this.userId, PERMISSION.USER);
    });
    return $modal;
  }

  _init() {
    this.loaded = false;
    this.cardModified = false;

    this.loadingMobileService.show();

    this.foodBenefitService
      .getUserDataSync()
      .then(() => {
        this._initData();
        this.loaded = true;
      })
      .finally(() => this.loadingMobileService.hide());
  }

  _initData() {
    this.employee = this.UserDataService.getEmployee();
    this.userId = this.employee.userId;
    this.employeeopplus = this.employee._profile.employeeopplus;
    this.employees = employeesDataFormatter.assemble(this.employee);
    this.employeesBackup = angular.copy(this.employees);
    if (this.isMobileApp) {
      this.employees = this.myFoodBenefitHelper.getOwnEmployee(
        this.employeesBackup,
        this.userId
      );
      this.delegatedEmployees = this.myFoodBenefitHelper.getDelegatedEmployees(
        this.employeesBackup,
        this.userId
      );
    }

    this.profile = this.employee.getProfile();
    this.employeeManager = this.ManagerForEmployeeService.getManagerForEmployee(
      this.userId
    );
    this._checkEmployeeHasManager();
    this._getDelegations();
    this.employeesIds = this.employees.map(
      this.myFoodBenefitHelper.getEmployeeToFilter
    );
    this.employeeFilters = [];
  }

  showModalWarningDelegation() {
    let delegationEmpty = this.helperDelegations.isDelegationEmpty(
      this.delegation
    );
    if (this.visitedDelegation || delegationEmpty) {
      return;
    }
    this.modalWarningDelegation.modal('show');
  }

  showEmployeeSearch() {
    return this.isMobileApp && this.delegatedEmployees.length > 0;
  }

  onSearch() {
    const searchFilter = this.isMobileApp
      ? _.map(this.delegatedEmployees, 'profile')
      : this.employeesIds;
    return this.helperDelegations.onSearchEmployeeDelegations(searchFilter);
  }

  _getDelegations() {
    this.loadingMobileService.show();
    this.foodDelegationService
      .getDelegations(this.userId)
      .then((delegations) => {
        this.delegationsObject = delegations;
        this.delegation = this.myFoodBenefitHelper.findDelegation(
          this.delegationsObject
        );
        this.showModalWarningDelegation();
      })
      .finally(() => this.loadingMobileService.hide());
  }

  onSelectEmployeeSearch($event) {
    const employeeIdInFilters = this.employeeFilters.find(
      (employee) => employee.employeeId === $event.employeeId
    );
    if (!employeeIdInFilters) this.employeeFilters.push($event);
    this.existFilters = true;
    this._updateFilters();
  }

  _updateFilters() {
    this.employees = this.employeesBackup.filter((employee) => {
      let id = employee.profile.employeeId || employee.profile.userId;
      return this.employeeFilters.some(
        (filter) => (filter.employeeId || filter.userId) === id
      );
    });

    this.delegatedEmployees = this.employees;
  }

  onCleanEmployeeFilters() {
    this.employeeFilters = [];
    this.employees = this.employeesBackup;
    this.existFilters = false;
  }

  onRemoveEmployeeFilter($event) {
    _.remove(
      this.employeeFilters,
      (filter) => filter.employeeId === $event.employeeId
    );
    if (this.employeeFilters.length === 0) {
      this.onCleanEmployeeFilters();
      return;
    }

    this._updateFilters();
  }

  _checkEmployeeHasManager() {
    this.loadingMobileService.show();

    this.ManagerForEmployeeService.getManagerForEmployee(this.userId)
      .then(
        (manager) => {
          if (manager.managerId === null) this.setNoManager();
          else this.hasNoManager = false;
        },
        (error) => {
          this.log.error('_checkEmployeeHasManager', error);
          this.setNoManager(error.data);
        }
      )
      .finally(() => this.loadingMobileService.hide());
  }

  setNoManager(errorData) {
    this.noManagerMessage = errorData ? errorData.message : 'No manager data';
    this.hasNoManager = true;
  }

  daysIsFocused($event) {
    this.daysInCardIsFocused = $event.isFocused;
  }

  showSendAllRequest() {
    return (
      this.isMobileApp &&
      this.cardModified &&
      !this.floatingActionButtonsService.isFocused &&
      !this.daysInCardIsFocused
    );
  }

  onModify(modifiedArray) {
    this.modifiedArray = modifiedArray;
    this.cardModified = this.myFoodBenefitHelper.checkMoreThanOneModified(
      this.modifiedArray
    );
  }

  onSendCard(card) {
    let arrayToSend = new Array();
    arrayToSend.push(card);
    arrayToSend = arrayToSend.map(this.myFoodBenefitHelper.formatRequest);
    this.requestType = REQUEST_TYPE.INDIVIDUAL;
    this.requestFoodBenefits(arrayToSend, card);
  }

  openModalRequestAll() {
    this.areCardsWithoutManager = this.checkAreModifiedCardsWithoutManager();
    this.countModifiedCards = this.modifiedArray.length;
    this.modalState = this.myFoodBenefitHelper.getModalStateSendAll();
    this.modalBenefitRequestList.modal('show');
  }

  checkAreModifiedCardsWithoutManager() {
    return this.modifiedArray.find(function (card) {
      return card.hasManager === false;
    });
  }

  hideModal() {
    this.modalBenefitRequestList.modal('hide');
  }

  onModalResponse($event) {
    this.modalAction = $event.status;
    let cardsToSend = this.modifiedArray.map(
      this.myFoodBenefitHelper.formatRequest
    );
    if ($event.status === MODAL_ACTIONS.CANCEL) {
      this.hideModal();
      return;
    }
    if ($event.status === MODAL_ACTIONS.SEND) {
      this.requestType = REQUEST_TYPE.COLLECTIVE;
      this.requestFoodBenefits(cardsToSend, null);
    }
  }

  onCloseCard() {
    this._initData();
  }

  requestFoodBenefits(requests, card) {
    this.loadingMobileService.show();
    this.foodBenefitService
      .requestFoodBenefits(requests, this.userId)
      .then(() => {
        this._reloadData(card, false);
        this.requestModal = requests;
        this.modalMessage = `${requests.length} ${this.allRequestApprovedText}`;
      })
      .catch((error) => {
        if (card === null) {
          this._showModalErrorWhenFailedSendAllCards(error.data.message);
        } else {
          card.requestErrorMsg = error.data.message;
        }

        this._reloadData(card, true);
      })
      .finally(() => this.loadingMobileService.hide());
  }

  _reloadData(card, isErrored) {
    this.cardModified = false;
    this.loadingMobileService.show();
    this.foodBenefitService
      .getUserDataSync()
      .then(() => {
        if (this.requestType !== REQUEST_TYPE.INDIVIDUAL) {
          this._initData();
        }

        if (isErrored) {
          this.setStateFailed(card);
        } else {
          this.setStateApprove(card);
        }
      })
      .finally(() => this.loadingMobileService.hide());
  }

  setStateApprove(card) {
    if (card) {
      this.newCardState = this.myFoodBenefitHelper.setCardStateApproved(
        card,
        this.employees
      );
    } else {
      this.modalState = this.myFoodBenefitHelper.getModalStateApproved();
    }
  }

  setStateFailed(card) {
    if (card) {
      this.newCardState = this.myFoodBenefitHelper.setCardStateFailed(
        card,
        this.employees
      );
    } else {
      this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
    }
  }

  _showModalErrorWhenFailedSendAllCards(messageError) {
    this.modalMessage = messageError;
    this.modalState = this.myFoodBenefitHelper.getModalStateFailed();
  }

  _assembleDelegatedEmployeeEdited(employee) {
    const employeeId = employee.profile.employeeId;
    return this.delegatedEmployees.map((delegated) => {
      const equalDelegated = delegated.profile.employeeId === employeeId;
      return equalDelegated ? employee : delegated;
    });
  }

  updateDelegatedEmployees($event) {
    let employeeEdited = $event;
    this.delegatedEmployees =
      this._assembleDelegatedEmployeeEdited(employeeEdited);
  }

  _translate() {
    return this.myFoodBenefitHelper
      .getApproveAllMessage()
      .then((translation) => {
        this.allRequestApprovedText = translation;
      });
  }

  onCleanSearch($event) {
    if ($event.searchText.length) {
      return;
    }

    this.timeout(() => {
      this.openEmployeeSearch = false;
      this.scrollToTop();
    });

    this.delegatedEmployees = this.myFoodBenefitHelper.getDelegatedEmployees(
      this.employeesBackup,
      this.userId
    );
    this.employeeFilters = [];
  }

  onClickOnEmployeeSearch() {
    this.openEmployeeSearch = true;
    this.scrollToTop();
  }

  scrollToTop() {
    $('html,body').animate({ scrollTop: 0 }, 'slow');
  }
}

export default MyFoodBenefitController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/myFoodBenefit/myFoodBenefit.controller.js